export default __webpack_public_path__ + "static/media/917.fe0f7bfb.png";